module.exports = __webpack_public_path__ + "img/Image20230731162751.5f79c62f.png";